import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { GMPResponse, useDashboardPieType } from "../../types";

export const useGMP = ({ date, location_id }: useDashboardPieType) => {
  const api = useApi();
  const [data, setData] = useState<GMPResponse | null>(null);

  const params: Record<string, string | number> = {
    year_month: date,
    ...(location_id && { location_id }),
  };

  const fetchData = () => {
    api.get("/dasboard_inventory/gmp_perlocation", { params })
    .then((res: SuccessFetch<{ payload: GMPResponse }>) => {
      const payload = res.data.payload;
      setData(payload);
    })
    .catch(() => setData(null));
  };

  useEffect(() => {
    fetchData();
    return () => setData(null);

    // eslint-disable-next-line
  }, [date, location_id]);

    return { fetchData, data };
}
